import { enableProdMode, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/browser';

import { environment } from './environments/environment';
import { SentryErrorHandler } from './app/error-handler';
import { provideHttpClient, withXhr, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: 'https://37d8bba73539406596a0e02e8b6b6beb@o341742.ingest.sentry.io/5356011',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  sampleRate: environment.sentryTraceRate,
  release: environment.sentryReleaseVersion,
  environment: environment.sentryEnvironment
});

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes),
        provideAnimations(),
        { provide: ErrorHandler, useClass: SentryErrorHandler },
        { provide: 'servicesBaseUrl', useValue: environment.servicesBaseUrl },
        { provide: 'signalRBaseUrl', useValue: environment.signalRBaseUrl },
        { provide: 'coreUrl', useValue: environment.coreUrl },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
